import React, { useRef, useEffect, useState } from "react"
import { ICellRendererParams } from "ag-grid-community"
import { Tooltip } from "@mui/material"
import "../agGridTable.scss"

const OverflowTooltipCell: React.FC<ICellRendererParams> = ({ value }) => {
    const cellRef = useRef<HTMLDivElement>(null)
    const [showTooltip, setShowTooltip] = useState(false)

    const checkOverflow = () => {
        const el = cellRef.current
        if (el) {
            setShowTooltip(el.scrollWidth > el.clientWidth)
        }
    }

    useEffect(() => {
        checkOverflow()

        const el = cellRef.current
        if (!el) return

        const resizeObserver = new ResizeObserver(() => {
            checkOverflow()
        })

        resizeObserver.observe(el)

        return () => resizeObserver.disconnect()
    }, [value])

    const getTooltipTitle = () => {
        if (typeof value === "string") {
            return value
        } else if (React.isValidElement(value) && typeof (value as React.ReactElement).props?.children === "string") {
            return (value as React.ReactElement).props?.children
        }
        return ""
    }

    return (
        <Tooltip
            title={showTooltip && getTooltipTitle()}
            disableHoverListener={!showTooltip}
            placement="top"
            enterTouchDelay={0}
            leaveTouchDelay={5000}
            disableInteractive={false}>
            <div
                ref={cellRef}
                className="tooltip-value"
                style={{
                    cursor: showTooltip ? "pointer" : "default",
                }}>
                {value}
            </div>
        </Tooltip>
    )
}

export default OverflowTooltipCell
